module.exports = __webpack_public_path__ + "static/media/瓦力机器人.8c10d012.png";